import { Command } from '@/app/common/base/command'

export class LogoutCommand extends Command {

    public async run() {
        await this.store.dispatch('auth/logout')
    }

}
